// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".rtl[data-v-ed7a1fee]{direction:rtl}.ltr[data-v-ed7a1fee]{direction:ltr}", ""]);
// Exports
module.exports = exports;
